/* src/app/shared/hrm/hrm.component.scss */
.hrm {
  position: absolute;
  width: 50vw;
  height: 50vw;
  background-size: contain;
}
.hrmIndex {
  position: absolute;
  width: 50vw;
  height: 50vw;
  background-size: cover;
  background-image: url(/assets/images/hrz_index.png);
}
.hrmParent {
  width: 50vw;
  height: 50vw;
  overflow: hidden;
}
.hrmStats {
  padding-top: 15vw;
  width: 50vw;
  height: 50vw;
  position: absolute;
  text-align: center;
}
.hrm1 {
  color: rgb(76, 76, 76);
  font-size: xx-large;
}
.hrm2 {
  color: rgb(0, 173, 239);
  font-size: xx-large;
}
.hrm3 {
  color: rgb(94, 186, 70);
  font-size: xx-large;
}
.hrm4 {
  color: rgb(240, 90, 40);
  font-size: xx-large;
}
.hrm5 {
  color: rgb(237, 28, 36);
  font-size: xx-large;
}
.hrmStats h1,
.hrmStats h2 {
  margin: 0;
  font-size: xx-large;
  color: black;
}
h1 {
  font-size: large !important;
}
/*# sourceMappingURL=hrm.component.css.map */
